import React from 'react';

import InfoIcon from '@mui/icons-material/Info';
import { Button, Stack, Tooltip } from '@mui/material';

type VoucherFormNavigationProps = {
  isSubmitting: boolean;
  isEdit: boolean;
  showAdvanceDescription: boolean;
  onBack: () => void;
  onSubmit: () => void;
  onToggleAdvancedDescription: () => void;
};

export default function VoucherFormNavigation({
  isSubmitting,
  isEdit,
  showAdvanceDescription,
  onBack,
  onSubmit,
  onToggleAdvancedDescription,
}: VoucherFormNavigationProps) {
  return (
    <Stack direction="row" spacing={2}>
      <Button variant="text" onClick={onBack} disabled={isSubmitting}>
        Back to list
      </Button>
      <Button variant="contained" color="primary" onClick={onSubmit} disabled={isSubmitting}>
        {isSubmitting ? (isEdit ? 'Saving...' : 'Creating...') : isEdit ? 'Save' : 'Create'}
      </Button>
      <Tooltip title={showAdvanceDescription ? 'Hide Advanced Description' : 'Show Advanced Description'}>
        <InfoIcon onClick={onToggleAdvancedDescription} />
      </Tooltip>
    </Stack>
  );
}
